import React, { Component } from 'react';
import Spiner from '../helpers/Spiner/Spiner';
import { downloadAnki, getCard } from './actions';
import Card from './components/Card/Card';
import './style.scss';
import PropTypes from 'prop-types'
import WrappedIntlComponent from '../common/intl/WrappedIntlComponent';

export class CardView extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
      download: false,
      cards: [],
      category: {},
      activeCard: 0,
      replay: false
    }
  }

  async componentDidMount(){
    
    console.log("🚀 ~ file: CardView.jsx ~ line 18 ~ CardView ~ componentDidMount ~ this.props.match", this.props.match)
    const { cards, category } = await getCard(this.props.match.params.id);
    console.log("🚀 ~ file: CardView.jsx ~ line 26 ~ CardView ~ componentDidMount ~ cards", cards, category)
    this.setState({
      loaded: true,
      cards,
      category,
      activeCard: 0
    })
  }

  changeCard = (index) => {
    // cards.length > 1 && cards.length - 1 == activeCard &&
    this.setState({activeCard: index, replay: false})
  }

  onOpen = () => {
    const {cards, activeCard } = this.state;
    console.log(cards.length > 1 && cards.length - 1 == activeCard)
    if(cards.length - 1 == activeCard){
      this.setState({replay: true})
    }
  }

  onDownloadAnki = async () => {
    try {
      this.setState({download: true})
      const data = await downloadAnki(this.props.match.params.id);
      if(data){
        window.open(data.url,'_blank');
      }
      this.setState({download: false})
    } catch (error) {
      this.setState({download: false})
    }
  }

  render() {
    const {cards, activeCard, loaded, replay, category, download} = this.state;
    const card = cards[activeCard];

    const {formatMessage} = this.props;

    if(!loaded){
      return <div className='CardView'>
        <Spiner/>
      </div>
    }

    return <div className="CardView">
      {download && <div className='spinner'>
        <div style={{height: 200}}>
          <Spiner/>
        </div>
        <h4>{formatMessage('downloadFileAnki')}</h4>
      </div>}
      {replay && <div className="replay">
        <div className="text">{formatMessage('cardCongratulations')}</div>
        <button className='btn btn-outline-secondary' onClick={() => {this.changeCard(0)}}>{formatMessage('cardreplay')}</button>
      </div>}
      {card && <Card 
        card={card}
        formatMessage={formatMessage}
        category={category}
        current={activeCard+1} 
        count={cards.length} 
        setCurrent={(v) => this.changeCard(v)}
        prevId={activeCard-1}
        nextId={cards[activeCard+1] ? activeCard+1 : -1}
        onOpen={this.onOpen}
        downloadAnki={this.onDownloadAnki}
      />}
      {!card && <div className='NotFound'>{formatMessage('cardNotFound')}</div>}
    </div>;
  }
}

export default WrappedIntlComponent(CardView);



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/CardView/CardView.jsx